import React, { Component } from 'react';
import './homework-list.scss';
import { Modal, ModalBody, Tooltip, ModalFooter, Button } from "reactstrap";
import { Constants, ImageConstants, AccessRights } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import Filter from './filter/filter'
import CompletionReport from '../completion-report/completion-report'
import HomeworkEvalutionReport from '../reports/evaluation-report/evaluation-report'
import StudentLevelReport from '../reports/student-level-report/student-level-report'
import HomeworkProgressionReport from '../reports/level-progression-report/level-progression-report'
import StudentDetailReport from '../reports/student-level-report/student-detail/student-detail'
import EloReport from '../reports/elo-report/elo-reportV1/elo-report'
import HomeworkApi from '../../../apis/homework'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import WronglyAnswered from '../../common/wrong-answers-modal/wrong-answers-modal'
import ArchiveModal from '../../common/archive/archive'
import ReminderModel from '../reminder/reminder'
import EloDetail from './elo-detail/elo-detail'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import Loading from '../../common/loading/loading'
import SessionCache from '../../routes/session-cache';
import NotificationModel from '../../tests-v3/test-list/notification/notification'
import SuccessComponent from '../../tests-v3/test-list/success/success'
import moment from 'moment';
import NewHomework from '../new-homework/new-homework'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
import QuestionList from '../new-homework/questions-list/questions-list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import SchoolApi from '../../../apis/school';

import Path from '../../routes/routes-path';
import { Link } from 'react-router-dom'



class HomeworkList extends Component {

    state = {
        homeworkList: [],
        tabs: [
            { title: "Active", value: "ACTIVE" },
            { title: "Past Due Date", value: "PAST_DUE_DATE" },
            { title: "Archived", value: "ARCHIVED" }
        ],
        activeTabIndex: 0,
        selectedFilters: [
            // { type: "Class", value: "7th" }
        ],
        meta: { totalPages: 1, page: 1 },
    }
    limit = 10
    filter = { status: "ACTIVE", }
    currentPage = 1;
    // pageLimit = 10

    accessRights = SessionCache.getAllowedModule()

    constructor(props) {
        super(props)
        if (this.props.filter) {
            this.filter = {
                status: "ACTIVE",
                board: this.props.filter?.board || "",
                class: this.props.filter?.class || "",
                chapter: this.props.filter?.chapterKey || ""
            }

        }
    }

    componentDidMount() {
        this.getHomeworkList(this.filter)
        document.addEventListener('mousedown', this.handleClickEvent, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    handleClickEvent = (event) => {
        if (this.studentRef && !this.studentRef.contains(event.target)) {
            this.setState({ userListIndex: -1 })
        }
    }


    getHomeworkList(payload = {}) {

        if (!payload.page) payload.page = 1
        if (!payload.limit) payload.limit = this.limit
        payload.type = this.props.type
        this.currentPage = payload.page

        if (this.currentPage === 1) this.startIndex = 1

        this.setState({ isLoading: true, meta: {} })
        HomeworkApi.getHomework(payload)
            .then(response => {
                console.log(response.response)
                this.buildHomeworkList(response.response)
                this.setState({ meta: response.meta, totalpages: response.meta.count, isLoading: false })

            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    buildHomeworkList(homeworks) {
        let homeworkGroup = {}, individualHomework = []
        let homeworkList = []
        for (let i = 0; i < homeworks.length; i++) {
            let homework = homeworks[i]
            let obj = {
                _id: homework._id,
                createdDateTimestamp: homework.countingwellCreatedTimestamp || homework.createdDate,
                createdDate: new Date(homework.countingwellCreatedTimestamp || homework.createdDate).toLocaleDateString("en-IN"),
                dueDate: new Date(homework.endDate).toLocaleDateString("en-IN"),
                chapter: homework?.chapter?.title,
                concepts: homework?.chapter?.concept,
                section: homework.section,
                class: homework.class,
                board: homework.board,
                completed: homework.completed,
                notCompleted: homework.notCompleted,
                status: homework.status,
                conceptBuild: homework?.chapter?.conceptBuild,
                notificationCount: homework?.notificationCount || 0,
                lastNotificationSentDate: homework?.lastNotificationSentDate,
                approximateQuestions: homework?.approximateQuestions,
                approximateTime: homework?.approximateTime,
                category: homework?.category,
                users: homework?.users || [],
                basePath: homework.basePath
            }

            if (homework.groupId) {
                if (homeworkGroup[homework.groupId]) {
                    homeworkGroup[homework.groupId].push(obj)
                } else {
                    homeworkGroup[homework.groupId] = [obj]
                }
            } else {
                individualHomework.push(obj)
            }

        }

        let groupedHomework = Object.values(homeworkGroup)

        homeworkList.push(...groupedHomework, ...individualHomework)

        this.setState({ homeworkList })

    }


    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                console.log(school)
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({selectedBoard: school?.boards[0]?.name, showWarningPopup: true })
                }
                this.setState({ classDropdownItems: classes, })
            }).catch(err => {
            })
    }


    expand = (item, index) => {
        // let homeworkList = this.state.homeworkList
        // homeworkList[index].expand = !homeworkList[index].expand
        this.setState({ showMoreInfo: true, selectedHomeworkMore: item })
    }

    hideMoreInfoModal = () => {
        this.setState({ showMoreInfo: false })
    }

    onClickTab = (index) => {
        this.setState({ activeTabIndex: index, selectedItemIndex: null, selectedItemGroupIndex: null })
        let tab = this.state.tabs[index]
        this.filter.status = tab.value
        this.filter.page = 1
        this.getHomeworkList(this.filter)
    }

    hideReport = () => {
        this.setState({ showReport: false, selectedReportType: '' })
    }

    onClickBack = () => {
        this.props.back && this.props.back()
    }

    onClickNewHomeWork = () => {
        this.getClasses()
        this.setState({ showNewHomework: true })
    }

    hideNewHomework = (value) => {

        if (value) {
            this.filter = { status: "ACTIVE" }
            this.getHomeworkList(this.filter)
        }

        this.setState({ showNewHomework: false, showWarningPopup : false })
    }

    showReport = (type, item, index, grpIndex) => {

        let pathname = `${type}${this.props.type}/${item._id}/${item.chapter}/${item.class}/${item.createdDateTimestamp}`

        this.setState({ showReport: false, selectedReportType: type, selectedHomework: item, selectedItemIndex: index, selectedItemGroupIndex: grpIndex })

        let origin = window.location.origin

        window.open(origin + pathname)

    }

    getTabs = () => {
        return (<div>
            {this.state.tabs.map((tab, index) => (
                <div key={'tab' + index} className={`tab mr-3 ${this.state.activeTabIndex == index ? 'tab-active' : ''}`} onClick={() => this.onClickTab(index)}>
                    <div className='tab-center'>
                        <span>{tab.title}</span>
                    </div>

                    {this.state.activeTabIndex == index ? <div className='active-cirlce'>
                    </div> : ""}
                </div>
            ))}
        </div>)
    }

    handleDateEvent = (event, picker, item, index) => {
        this.dueDate = picker.startDate ? (new Date(new Date(picker.startDate).setHours(23, 59, 59, 999)).toISOString()) : ''

        let payload = { homeworkId: item._id, dueDate: this.dueDate, }
        HomeworkApi.updateHomework(payload)
            .then(response => {
                this.getHomeworkList(this.filter)
            }).catch(err => {
            })
    }

    hideWrongAnswersReport = () => {
        this.setState({ showWrongAnswersReport: false })
    }

    hideStudentLevelReport = () => {
        this.setState({ showStudentLevelReport: false })
    }

    hideReminderModal = () => {
        this.setState({ showReminderModal: false })
    }

    onOkArchiveModal = () => {
        this.setState({ showArchiveModal: false })
    }

    onCloseArchiveModal = () => {
        this.setState({ showArchiveModal: false })
    }

    onCLickNotitification(item, type) {
        this.setState({ notificationType: type, selectedItem: item, showNotification: true })
    }

    hideNotification = () => {
        this.setState({ showNotification: false })
    }

    onSentNotification = () => {
        this.hideNotification()
        this.showToaster('info', "Message shared successfully")
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 5000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }


    renderReminderModal = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideReminderModal} size={'lg'}>
                <ModalBody >
                    <ReminderModel message={this.state.reminderMessage} notCompleted={this.state.notCompleted} homeworkId={this.state.reminderHomeworkId} notificationCount={this.state.notificationCount} notificationDate={this.state.notificationDate} back={this.hideReminderModal} />
                </ModalBody>
            </Modal>
        )
    }

    renderNotificationIcons(item) {
        return (
            <div className="notification-icons">
                <span className="pt-2 mr-2">
                    <img alt="" className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.EMAIL)} onClick={() => this.onCLickNotitification(item, "EMAIL")} />
                </span>
                <span className="pt-2">
                    <img alt="" className="icon-20 cursor-pointer" src={getImageSource(ImageConstants.WHATSAPP)} onClick={() => this.onCLickNotitification(item, "WHATSAPP")} />
                </span>
            </div>
        )
    }

    onChangeType = (type) => {
        this.setState({ notificationType: type })
    }

    showSuccessModal = (item) => {
        this.setState({ showSuccess: true, selectedItem: item })
    }

    onInviteMoreStudent = () => {
        this.setState({ showSuccess: false, notificationType: "WHATSAPP", showNotification: true })
    }

    closeSuccess = () => {
        this.setState({ showSuccess: false })
    }

    renderNotificationModal = () => {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideNotification} size={'lg'}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img alt="" className="close-icon cursor-pointer" onClick={this.hideNotification} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="header-text text-center pt-4">
                        <span>SHARE THE INVITE WITH STUDENTS</span>
                    </div>
                    <NotificationModel type={this.state.notificationType} from="HOMEWORK" assessment={this.state.selectedItem} onChangeType={this.onChangeType} onOk={this.onSentNotification} />
                </ModalBody>
            </Modal>
        )
    }


    getHomeworkCard = (item, index, groupIndex) => {

        return (
            <div className='homework-card'>
                <div className='row m-0'>
                    <div className='col border-bottom border-right'>
                        <span className='header-label'>Created: <strong>{item.createdDate}</strong></span>
                    </div>
                    <div className='col border-bottom'>
                        <span className='header-label'>Due: <strong className="pr-2">{item.dueDate}</strong>
                            {
                                this.checkEditCondtion() ?
                                    <DateRangePicker onApply={(event, picker) => this.handleDateEvent(event, picker, item, index, groupIndex)}
                                        initialSettings={{ singleDatePicker: true, minDate: this.startDate ? this.startDate : new Date() }}
                                    >
                                        <img className="edit-icon" src={getImageSource(ImageConstants.EDIT)} />
                                    </DateRangePicker>
                                    : ""
                            }
                        </span>
                    </div>
                </div>

                <div className='p-3'>
                    <div className='row'>
                        <div className='col'>
                            <div className='body-title'>Chapter</div>
                            <div className='body-sub-title pt-2'><strong>{item.chapter}</strong></div>
                        </div>
                        <div className='col'>
                            <div className='row'>
                                <div>
                                    <div>Qs: <strong>{item.approximateQuestions}</strong></div>
                                </div>
                                <div className='ml-2'>
                                    <div>Time: <strong>{item.approximateTime}m</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row pt-3'>
                        <div className='col'>
                            <div className='body-title'>Concepts</div>
                            {item.concepts?.map(concept => (
                                <div className='body-sub-title pt-2'><strong>{concept && concept.title ? concept.title : ""}</strong></div>
                            ))}
                        </div>
                    </div>

                    {
                        item.expand ? <div className='pt-3'>
                            <div className='body-title'>Learning Outcome</div>

                            {item.elos.map(elo => (
                                <div className='body-sub-title pt-2'><strong>{elo.title}</strong></div>
                            ))}
                        </div> : ''}

                    <div className='pt-3 row more-color'>
                        <div className='col my-auto'><span className='cursor-pointer' onClick={() => this.expand(item, index)}>{item.expand ? 'Less' : 'More >>'}</span></div>
                        <div className='col'>
                            {
                                item?.status != "ARCHIVED" ? this.getActions(item, index, groupIndex) : ""
                            }
                        </div>
                    </div>
                </div>

            </div>
        )

    }

    renderStatus = (item, index, grpIndex) => {
        return (<div>
            <div className='completed'>
                <div className='completed-text'>
                    <div className='cursor-pointer' onClick={() => { this.showReport(Path.HOMEWORK_COMPLETION_REPORT, item, index, grpIndex) }} >
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.CORRECT)} />
                        </span>
                        <span className="float-right">
                            {item.completed && item.completed.length ? item.completed.length : 0}
                        </span>
                    </div>
                </div>
            </div>

            <div className='not-completed mt-3'>
                <div className='not-completed-text'>
                    <div className='cursor-pointer' onClick={() => { this.showReport(Path.HOMEWORK_COMPLETION_REPORT, item, index, grpIndex) }}>
                        <span>
                            <img className="status-image" src={getImageSource(ImageConstants.WRONG)} /></span>
                        <span className="float-right">
                            {item.notCompleted && item.notCompleted.length ? item.notCompleted.length : 0}
                        </span>
                    </div>
                </div>
            </div>
        </div>)
    }

    onCLickStudentLevelReport(item) {
        this.setState({ showStudentLevelReport: true, selectedHomework: item })
    }

    getReportList = (item, index, grpIndex) => {
        console.log(".....", index)

        if (this.props.type == 'STANDARD') {
            return (
                <div>
                    <div className='row'>
                        <div className='col-7 px-0'>
                            {/* <Link className='report-wrapper' to={
                                {pathname:`${Path.HOMEWORK_COMPLETION_REPORT}${this.props.type}/${item._id}/${item.chapter}/${item.class}/${item.createdDateTimestamp}`,  
                                state:"Hello World"}} target='_blank' onClick={() => { this.showReport('COMPLETION_REPORT', item, index) }}>
                                <img className='report-icon' src={getImageSource(ImageConstants.COMPLETION_REPORT)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Completion Report</span>
                            </Link> */}
                            <div className='report-wrapper' onClick={() => { this.showReport(Path.HOMEWORK_COMPLETION_REPORT, item, index) }}>
                                {/* <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION_REPORT)} /> */}
                                <span className={`${item.completed ? "blue" : ""}`}>Completion Report</span>
                            </div>

                            {/* <img className='report-icon' src={getImageSource(ImageConstants.COMPLETION_REPORT)} /> */}
                            {/* <span className={`${item.completed ? "blue" : ""}`} >Completion Report</span> */}

                            {/* <Link to={Path.HOMEWORK_ASSIGN} target="_blank">
                                        Completion Report      
                            </Link> */}
                        </div>

                        <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.showDownloadReport(item, "COMPLETION_REPORT")}>
                            {/* <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} /> */}
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport(Path.HOMEWORK_EVALUATION_REPORT, item, index)}>
                                {/* <img className='report-icon' src={getImageSource(ImageConstants.HOMEWORK_EVALUATION_REPORT)} /> */}
                                <span className={`${item.completed ? "blue" : ""}`}>Homework Evaluation Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.showDownloadReport(item, "HOMEWORK_EVALUATION_REPORT")}>
                            {/* <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} /> */}
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport(Path.MOST_WRONG_REPORT, item, index)}>
                                {/* <img className='report-icon' src={getImageSource(ImageConstants.MOST_WRONGLY_ANSWERED)} /> */}
                                <span className={`${item.completed ? "blue" : ""}`}>Most Wrong Questions</span>
                            </div>
                        </div>

                        {/* <div className='col-5 download-icon-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div> */}
                    </div>

                    {/* <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.onCLickStudentLevelReport(item)}>
                                <span className={`${item.completed ? "blue" : ""}`}>Student Level Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}

                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport(Path.ELO_LEVEL_REPORT, item, index)}>
                                <span className={`${item.completed ? "blue" : ""}`}>Learning Outcome Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper cursor-pointer' onClick={() => this.showDownloadReport(item, "ELO_LEVEL_REPORT")}>
                            {/* <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} /> */}
                        </div>
                    </div>
                    {/* <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showDownloadReport(item, "overall")}>
                                <span className={`${item.completed ? "blue" : ""}`}>Download Overall Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper cursor-pointer'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}
                </div>
            )
        }

        if (this.props.type == 'ADAPTIVE') {
            return (
                <div>
                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport(Path.HOMEWORK_COMPLETION_REPORT, item, index, grpIndex)}>
                                {/* <img className='report-icon' src={getImageSource(ImageConstants.COMPLETION_REPORT)} /> */}
                                <span className={`${item.completed ? "blue" : ""}`}>Completion Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper' onClick={() => this.showDownloadReport(item, "COMPLETION_REPORT")}>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport(Path.HOMEWORK_EVALUATION_REPORT, item, index, grpIndex)}>
                                <span className={`${item.completed ? "blue" : ""}`}>Homework Evaluation Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper' onClick={() => this.showDownloadReport(item, "HOMEWORK_EVALUATION_REPORT")}>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport(Path.MOST_WRONG_REPORT, item, index, grpIndex)} >
                                {/* <img className='report-icon' src={getImageSource(ImageConstants.MOST_WRONGLY_ANSWERED)} /> */}
                                <span className={`${item.completed ? "blue" : ""}`}>Most Wrong Questions</span>
                            </div>
                        </div>

                        {/* <div className='col-5 download-icon-wrapper' onClick={() => this.showDownloadReport(item, "MOST_WRONG_REPORT")}>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div> */}
                    </div>
                    <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport(Path.ELO_LEVEL_REPORT, item, index, grpIndex)}>
                                <span className={`${item.completed ? "blue" : ""}`}>Learning Outcome Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper' onClick={() => this.showDownloadReport(item, "ELO_LEVEL_REPORT")}>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div>

                    {/* <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showDownloadReport(item, "overall")}>
                                <span className={`${item.completed ? "blue" : ""}`}>Download Overall Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}
                    {/* <div className='row'>
                        <div className='col-7 px-0'>
                            <div className='report-wrapper' onClick={() => this.showReport('LEVEL_PROGRESSION_REPORT', item)}>
                                <span className={`${item.completed ? "blue" : ""}`}>Level Progression Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}

                    {/* <div className='row'>
                        <div className='col-5'>
                            <div className='report-wrapper' onClick={() => this.showReport('LEVEL_IMPROVEMENT_REPORT')}>
                                <img className='report-icon' src={getImageSource(ImageConstants.LEVEL_IMPROVEMENT_REPORT)} />
                                <span className={`${item.completed ? "blue" : ""}`}>Level Improvement Report</span>
                            </div>
                        </div>

                        <div className='col-5 download-icon-wrapper'>
                            <img className='report-icon' src={getImageSource(ImageConstants.DOWNLOAD_ICON)} />
                        </div>
                    </div> */}
                </div>
            )
        }
    }

    showDownloadReport = (item, reportType) => {
        this.setState({
            isDownloading: true,
            selectedItem: item
        }, _ => {
            this.downloadReport(item, reportType)
        })
    }

    downloadReport(item, reportType) {
        const payload = {
            type: this.props.type,
            reportType
        }
        if (item) {
            payload.id = item._id
        }

        HomeworkApi.downloadHomeworkReport(payload)
            .then(response => {
                if (response.url) {
                    window.open(response.url)
                }
                this.setState({ isDownloading: false })
            }).catch(err => {
                this.setState({ isDownloading: false })
                this.showToaster('info', `${err?.response?.data?.message || "Something went wrong"} `)
            })
    }

    getReminderAction() {
        if (this.props.type == "ADAPTIVE") {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_REMINDER]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_REMINDER]
        }
    }

    getArchivedAction() {
        if (this.props.type == "ADAPTIVE") {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_ARCHIVE]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_ARCHIVE]
        }
    }

    onClickReminderModal(item) {
        let concept = item.concepts?.map(i => i.title) || []
        let [d, m, y] = item.dueDate.split("/")

        if (m.length == 1) {
            m = `0${m}`
        }
        if (d.length == 1) {
            d = `0${d}`
        }
        let dateString = `${y}-${m}-${d}`
        let date = moment(dateString).format("Do MMM")
        let message = `Homework assigned to you from chapter ${item?.chapter || ""}  & concepts ${concept.join(",")} is still pending. Please complete it soon before due date i.e ${date}.`
        let notificationCount = item.notificationCount
        let notificationDate = item.lastNotificationSentDate
        this.setState({
            reminderHomeworkId: item._id,
            reminderMessage: message,
            showReminderModal: true,
            notificationCount,
            notificationDate,
            notCompleted: item?.notCompleted?.length
        })
    }

    getEloDetails(item) {

        let concepts = [], elos = []
        item.concepts.forEach(element => {
            concepts.push(element.key)
            element.elos.forEach(item => {
                elos.push(item.id)
            })

        });

        let payload = {
            class: item?.class,
            board: item?.board,
            section: item?.section,
            chapter: item?.chapter,
            concepts: concepts.join(","),
            elos: elos.join(",")
        }

        if (!payload.class || !payload.board || !payload.chapter) return

        HomeworkApi.getHomeworkEloDetails(payload)
            .then(response => {
                this.setState({
                    questionCount: response.questionCount,
                    contents: response.content,
                    approximateTime: response.questionCount, //ask by ravi
                    questionLoading: false,
                    showQuestionList: true,
                })
            }).catch(err => {
            })
    }

    onClickQuestionList(item, index, groupIndex) {
        this.setState({
            selectedQuestionList: item,
            contents: [],
            questionLoadingIndex: index,
            questionLoadingGroupIndex: groupIndex,
            questionLoading: true
        })

        this.getEloDetails(item)
    }

    hideQuestionList = () => {
        this.setState({ showQuestionList: false })
    }

    showQuestionList = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideQuestionList} size={'lg'}>
                <ModalBody >
                    <QuestionList back={this.hideQuestionList} contents={this.state.contents} />
                </ModalBody>
            </Modal>
        )
    }


    getActions = (item, index, groupIndex) => {

        if (!groupIndex) groupIndex = 0

        return (
            <div className="text-right">
                {
                    this.getArchivedAction()
                        ? <>
                            <img alt="" className='action-icon cursor-pointer' id={`rchived-tooltip-${index}_${groupIndex}`} src={getImageSource(ImageConstants.ARCHIVE)} onClick={() => this.setState({ showArchiveModal: true, selectedHomework: item })} />
                            <Tooltip className={`${this.state.tooltipOpenIndex === index && this.state.tooltipGroupIndex === groupIndex ? "show" : "hide-tooltip"}`} placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={`rchived-tooltip-${index}_${groupIndex}`} toggle={() => { this.setState({ tooltipOpen: !this.state.tooltipOpen, tooltipOpenIndex: index, tooltipGroupIndex: groupIndex }) }}>
                                Archive
                            </Tooltip>
                        </>
                        : ""
                }
                <span className="pl-4">
                    {
                        this.getReminderAction() ?
                            <>
                                <img alt="" className='action-icon cursor-pointer' id={`reminder-tooltip-${index}_${groupIndex}`} src={getImageSource(ImageConstants.REMAINDER)} onClick={() => this.onClickReminderModal(item)} />
                                <Tooltip className={`${this.state.reminderToolTipIndex === index && this.state.reminderToolTipGroupIndex === groupIndex ? "show" : "hide-tooltip"}`} placement="top" isOpen={this.state.reminderTooltipOpen} autohide={false} target={`reminder-tooltip-${index}_${groupIndex}`} toggle={() => { this.setState({ reminderTooltipOpen: !this.state.reminderTooltipOpen, reminderToolTipIndex: index, reminderToolTipGroupIndex: groupIndex }) }}>
                                    Reminder
                                </Tooltip>
                            </>
                            : ""
                    }
                </span>
            </div>
        )

    }

    categoryColor(category) {
        if (category === "ADVANCED") return "bg-lite-blue"
        if (category === "PROFICIENT") return "bg-orange"

        return "bg-purble"
    }

    getCategoryText(category) {

        if (category === "ADVANCED") return "Advanced"
        if (category === "PROFICIENT") return "Proficient"

        return "Novice"
    }

    onClickUserList(index, groupIndex) {
        this.setState({ userListIndex: index, userListGroupIndex: groupIndex })
    }

    onHideUserList() {
        this.setState({ userList: [], userListIndex: "", userListGroupIndex: "" })

    }

    renderUserList(item) {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.onHideUserList()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {
                    item?.users?.length ? item.users.map((user, index) =>
                        <div className='px-4 py-2 row align-items-center'>
                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {user.image ? <img className="" alt="img" src={`${item.basePath}${user.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div>
                            <div className='student-name ml-2'>
                                {user.name}
                            </div>
                        </div>

                    )
                        :
                        <div className="text-center pt-4">No Records Found</div>
                }
            </div>
        )
    }

    renderTableRow(item, index) {

        if (Array.isArray(item)) {

            return item.map((element, groupIndex) => (
                <tr key={element._id} className={`${groupIndex === item.length - 1 ? "tr-divider" : "tr-divider-lite"} ${index === this.state.selectedItemIndex && groupIndex === this.state.selectedItemGroupIndex ? "tr-bg-color" : ''} `} >
                    <td>{this.getHomeworkCard(element, index, groupIndex)}</td>
                    <td>
                        <span className="px-4">{element.class} {element.section}</span>
                        {element?.category ? <div className="mt-1"><span className={`category-badge ${this.categoryColor(element?.category)}`}>{this.getCategoryText(element?.category)}</span></div> : ""}
                        <div className="mt-4 pl-4" >
                            <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.USER1)} onClick={() => this.onClickUserList(index, groupIndex)} />
                            <div className="pl-4">
                                {
                                    this.state.userListIndex === index && this.state.userListGroupIndex == groupIndex ? this.renderUserList(element) : ""
                                }
                            </div>
                        </div>

                        <div className="mt-4 pl-4" >
                            {
                                this.state.questionLoading && this.state.questionLoadingIndex === index && this.state.questionLoadingGroupIndex === groupIndex ?
                                    <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                    :
                                    <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.BULLET_LIST)} onClick={() => this.onClickQuestionList(element, index, groupIndex)} />}
                        </div>
                    </td>
                    <td>{this.renderStatus(element, index, groupIndex)}</td>
                    <td>{this.getReportList(element, index, groupIndex)}</td>
                    <td>{this.renderNotificationIcons(element)}</td>
                </tr>
            ))
        }

        return (

            <tr key={item._id} className={`tr-divider ${index === this.state.selectedItemIndex ? "tr-bg-color" : ''}`}>
                <td>{this.getHomeworkCard(item, index)}</td>
                <td>
                    <span className="px-4">{item.class} {item.section}</span>
                    <div className="mt-4 pl-4" >
                        <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.USER1)} onClick={() => this.onClickUserList(index, 0)} />
                        <div className="mt-2 pl-4">
                            {
                                this.state.userListIndex === index && this.state.userListGroupIndex === 0 ? this.renderUserList(item) : ""
                            }
                        </div>
                    </div>
                    <div className="mt-4 pl-4" >
                        {
                            this.state.questionLoading && this.state.questionLoadingIndex === index && this.state.questionLoadingGroupIndex === 0 ?
                                <FontAwesomeIcon size="2x" icon={faSpinner} spin />
                                :
                                <img alt="" className="icon-30 cursor-pointer" src={getImageSource(ImageConstants.BULLET_LIST)} onClick={() => this.onClickQuestionList(item, index, 0)} />
                        }
                    </div>
                </td>
                <td>{this.renderStatus(item, index)}</td>
                <td>{this.getReportList(item, index)}</td>
                <td>{this.renderNotificationIcons(item)}</td>
            </tr>
        )
    }

    renderList = () => {
        return (
            <div className='tabs-wrapper'>
                <div className='tabs ml-5'>
                    {this.getTabs()}
                </div>
                <div id="table-scoll" className="table-responsive mt-8">
                    <table className="table cw-table mb-0 align-items-center custom-homework-table">
                        <thead>
                            <tr className="tr-divider-thin">
                                <th className='th-left-radius homework-text'>Homework</th>
                                <th><span className="px-4">Class</span></th>
                                <th>Status</th>
                                <th>Reports</th>
                                <th className="th-right-radius"></th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {
                                this.state.homeworkList && this.state.homeworkList.length ? this.state.homeworkList?.map((item, index) => (
                                    this.renderTableRow(item, index)
                                ))
                                    : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Record's found</td></tr>
                            }
                        </tbody>
                    </table>
                </div >
            </div>
        )
    }

    renderReport = () => {

        switch (this.state.selectedReportType) {

            case "HOMEWORK_EVALUATION_REPORT":
                return <HomeworkEvalutionReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} onClickStudent={this.onClickStudent} />

            case "COMPLETION_REPORT":
                return <CompletionReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} />

            case "LEVEL_PROGRESSION_REPORT":
                return <HomeworkProgressionReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} />

            case "STUDENT_DETAIL_REPORT":
                return <StudentDetailReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} student={this.state.selectedStudent} />

            case "ELO_LEVEL_REPORT":
                return <EloReport type={this.props.type} delegate={this} selectedItem={this.state.selectedHomework} student={this.state.selectedStudent} />

            case "MOST_WRONG_REPORT":
                return <WronglyAnswered show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />
            default:
                break
        }
    }

    renderFilters = () => {
        return (
            <div>{this.state.selectedFilters.map((filter, index) => (

                Array.isArray(filter.value) ?
                    filter.value?.length ?

                        <div key={'filter' + index} className='mr-2 selected-filter-container mt-4'>
                            <div className='filter-type'>{filter.type}</div>
                            {filter.value.map((item, filterIndex) =>
                                <>
                                    <div className='filter-value'>{item.title}</div>
                                </>
                            )}
                        </div>
                        : ""
                    :
                    filter.value ?
                        <div key={'filter' + index} className='selected-filter-container mr-2 mt-4'>
                            <div className='filter-type'>{filter.type}</div>
                            <div className='filter-value'>{filter.value}</div>
                        </div>
                        : ""
            ))}
            </div>
        )
    }

    showEloDetail = () => {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideMoreInfoModal} size={'lg'}>
                <ModalBody >
                    <EloDetail back={this.hideMoreInfoModal} item={this.state.selectedHomeworkMore} />
                </ModalBody>
            </Modal>
        )

    }

    onClickArchive = (item) => {
        let payload = { homeworkId: item._id, status: "ARCHIVED" }
        HomeworkApi.updateHomework(payload)
            .then(response => {

                this.setState({ showArchiveModal: false }, () => {
                    this.getHomeworkList(this.filter)
                })

            }).catch(err => {
            })
    }

    onFilterGo = (payload) => {

        if (!payload) {
            this.filter.board = ''
            this.filter.class = ''
            this.filter.section = ''
            this.filter.chapter = ''
            this.filter.concepts = ''
            this.filter.elos = ''
            this.filter.createdDateRangeStart = ''
            this.filter.createdDateRangeEnd = ''
            this.filter.dueDateRangeStart = ''
            this.filter.dueDateRangeEnd = ''
            this.getHomeworkList({ status: this.state.tabs[this.state.activeTabIndex].value })
            this.setState({ selectedFilters: [] })
        } else {

            let filters = []

            let filter = { ...this.filter }

            if (payload.createdDateRangeStart && payload.createdDateRangeEnd) {

                if (payload.createdDateFilter) {
                    filters.push({ type: 'Created Date', value: payload.createdDateFilter })
                }

                this.filter.createdDateRangeStart = payload.createdDateRangeStart
                this.filter.createdDateRangeEnd = payload.createdDateRangeEnd
            }

            if (payload.dueDateRangeStart && payload.dueDateRangeEnd) {

                if (payload.dueDateFilter) {
                    filters.push({ type: 'Due Date', value: payload.dueDateFilter })
                }

                this.filter.dueDateRangeStart = payload.dueDateRangeStart
                this.filter.dueDateRangeEnd = payload.dueDateRangeEnd
            }

            if (payload.board) {
                filters.push({ type: 'Board', value: payload.board })
                this.filter.board = payload.board
            }

            if (payload.class) {
                filters.push({ type: 'Class', value: payload.class })
                this.filter.class = payload.class
            }

            if (payload.section) {
                if (payload.section) {
                    filters.push({ type: 'Section', value: payload.sectionObject })
                }
                this.filter.section = payload.section
            }

            if (payload.chapter) {
                if (payload.chapterObject) {
                    filters.push({ type: 'Chapter', value: payload.chapterObject.title })
                }
                this.filter.chapter = payload.chapter
            }

            if (payload.concepts) {
                if (payload.conceptsObject) {
                    filters.push({ type: 'Concepts', value: payload.conceptsObject })
                }
                this.filter.concepts = payload.concepts
            }

            if (payload.elos) {
                if (payload.eloObject) {
                    filters.push({ type: 'Learning Outcomes', value: payload.eloObject })
                }
                this.filter.elos = payload.elos
            }

            console.log(filters)

            this.setState({ selectedFilters: filters })

            this.getHomeworkList(this.filter)

        }


    }

    onPageSelected = (selectedPage, startIndex) => {
        let payload = {
            page: selectedPage,
        }
        this.startIndex = startIndex
        this.filter.page = selectedPage
        this.setState({ selectedPage, selectedItemIndex: null, selectedItemGroupIndex: null })
        this.getHomeworkList(this.filter)
    }

    checkCreateCondtion() {
        if (this.props.type == 'ADAPTIVE') {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_CREATE]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_CREATE]
        }
    }

    checkEditCondtion() {
        if (this.props.type == 'ADAPTIVE') {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_EDIT]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_EDIT]
        }
    }

    onClickStudent = (student) => {
        this.setState({ selectedStudent: student }, () => {
            this.showReport("STUDENT_DETAIL_REPORT", this.state.selectedHomework)
        })
    }

    showRewardToaster = (item) => {
        if (item.point) {
            this.showToaster('info', `🎁 YAY! You just earned ${item.point} reward points for assigning the Homework ${item?.totalUsers || 0} students from ${item.class}${item.section ? " " + item.section : ""}`)
        }
    }

    render() {
        if (this.state.showNewHomework && (this.state.boardsDropdownItems?.length !== 0 && this.state.classDropdownItems?.length !== 0)) {
            return <NewHomework type={this.props.type} delegate={this} />
        }

        if (this.state.showNewHomework && ( this.state.boardsDropdownItems?.length == 0 || this.state.classDropdownItems?.length == 0)) {
            return <Modal className="cw-custom-modal-center modal-md" isOpen={true} toggle={this.hideNewHomework} size={''}>
                <ModalBody >
                    <div className='d-flex flex-column'>
                        <div className='margin-left'>CLASS & SECTION NOT ASSIGNED</div>
                        <div className='sub-text'>Please request the admin to assign a Class & Section to
                            your profile in order to create a Homework</div>
                    </div>
                </ModalBody>
                <ModalFooter className='justify-content-center'>
                    <Button color="primary" onClick={this.hideNewHomework}>GOT IT</Button>{' '}
                    {/* <Button color="secondary" onClick={this.toggle}>Cancel</Button> */}
                </ModalFooter>
            </Modal>
        }


        if (this.state.showReport) {
            return this.renderReport()
        }


        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}

                <div className='homework-list'>

                    <div>
                        {/* <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.onClickBack} /> */}
                        {
                            this.checkCreateCondtion() ?
                                <button className='float-right cw-btn-md d-inline-block cw-btn-primary' onClick={() => this.onClickNewHomeWork()}>
                                    New Homework
                                </button> : ""
                        }
                    </div>

                    <div className='mt-5'>
                        <Filter delegate={this} />

                        <img className='seperator' src={getImageSource(ImageConstants.FILTER_SEPERATOR)} />
                    </div>
                    <div className='screen-title mt-3'>{this.props.type === "ADAPTIVE" ? "Personalised " : ""}Homework List</div>

                    {this.renderFilters()}

                    {this.renderList()}

                    <div className='card-footer'>
                        {
                            this.state.meta.totalPages ?
                                <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta.totalPages} onPageSelected={this.onPageSelected.bind(this)} /> : ''
                        }
                    </div>
                    {/* {this.state.showWrongAnswersReport && <WronglyAnswered show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} selectedItem={this.state.selectedHomework} />} */}
                    {this.state.showStudentLevelReport && <StudentLevelReport show={this.state.showStudentLevelReport} delegate={this} close={this.hideStudentLevelReport} selectedItem={this.state.selectedHomework} onClickStudent={this.onClickStudent} />}
                    {this.state.showReminderModal ? this.renderReminderModal() : ""}
                    {this.state.showArchiveModal && <ArchiveModal title="Are you sure you want to Archive this Homework?" delegate={this} onOk={this.onOkArchiveModal} onClose={this.onCloseArchiveModal} selectedItem={this.state.selectedHomework} />}
                    {this.state.showMoreInfo ? this.showEloDetail() : ""}
                    {this.state.showNotification ? this.renderNotificationModal() : ""}
                    {this.state.showSuccess ? <SuccessComponent
                        title="HOMEWORK CREATED and SHARED WITH STUDENTS"
                        subTitle="Do You want to invite more students to take this homework?"
                        students={this.state?.selectedItem?.totalUsers || 0}
                        close={this.closeSuccess}
                        onOk={this.onInviteMoreStudent}
                        class={this.state?.selectedItem?.class}
                        section={this.state?.selectedItem?.section}
                    /> : ""}
                    {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
                    {
                        this.state.showQuestionList ? this.showQuestionList() : ""
                    }
                    {this.state.isDownloading && (
                        <Modal className="cw-custom-modal" isOpen={this.state.isDownloading} size={'md'}>

                            <ModalBody >
                                <div className="add-admin">
                                    <div className="header-text text-center">
                                        <span>{`Downloading Report...`}</span>
                                    </div>
                                    <div className='row px-5 py-5 margin-auto'>
                                        <img
                                            className='loader-icn'
                                            src={getImageSource(
                                                ImageConstants.PRE_LOADER_GIF
                                            )}
                                        />
                                    </div>
                                </div>
                            </ModalBody>

                        </Modal >
                    )}

                </div >
            </>);
    }
}

export default HomeworkList;